module.exports = __webpack_public_path__ + "img/check-white.7588f62d.svg";